<template>
  <div class="container">
    <div class="i-aqi">
      <aqidiv style="height: 100%" :imglist="color_aqi.lv1" :value="120" />
    </div>
    <div class="i-name">
      <div align="center" class="carddiv text-center">
        <ul style="list-style: none">
          <li class="p-2">
            <h3 class="textHeader">Real Time Weather Conditions</h3>
          </li>
        </ul>
      </div>
    </div>
    <div class="i-i1 p-2">
      <weatherCond
        :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (26).gif')
        "
        :unit="'°C'"
        :imglist="color_wa"
        :head="'Temperature'"
        :value="25.06"
      />
    </div>
    <div class="i-i2 p-2">
      <weatherCond
        :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (27).gif')
        "
        :unit="'%'"
        :imglist="color_wa"
        :head="'Relative Humidity'"
        :value="96.8"
      />
    </div>
    <div class="i-i3 p-2">
      <weatherCond
        :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (32).gif')
        "
        :unit="'m/s'"
        :imglist="color_wa"
        :head="'Wind Speed'"
        :value="3.9"
      />
    </div>
    <div class="i-name2">
      <div align="center" class="carddiv text-center">
        <ul style="list-style: none">
          <li class="p-2">
            <h3 class="textHeader">Real Time Air Pollution</h3>
          </li>
        </ul>
      </div>
    </div>
    <div class="i-o p-2">
      <o2 />
    </div>
  </div>
</template>

<script>
import o2 from "../components/o2.vue";
import aqidiv from "../components/aqi.vue";
import weatherCond from "../components/WeatherConditions.vue";
export default {
  components: { aqidiv, weatherCond, o2 },
  data() {
    return {
      color_wa: {
        text: "Good",
        head: "rgba(98, 201, 147, 0.9)",
        cr: "#90E4B8",
        bg: "rgba(185, 226, 205, 0.9)",
        color: "#111111",
      },
      color_aqi: {
        lv1: {
          text: "Good",
          textth: "ดี",
          bg: "rgba(118, 210, 80, 0.9)",
          img: require("@/assets/images/aqi/aqi_l1.png"),
          color: "#1b6106",
        },
        lv2: {
          text: "Moderate",
          textth: "ปานกลาง",
          img: require("@/assets/images/yamahaaqi/lv/lv2.png"),
          bg: "rgba(201, 210, 80, 0.9)",
          color: "#5f6106",
        },
        lv3: {
          text: "Unhealthy",
          textth: "เริ่มมีผลต่อสุขภาพ",
          img: require("@/assets/images/yamahaaqi/lv/lv3.png"),
          bg: "rgba(210, 158, 80, 0.9)",
          color: "#613706",
        },
        lv4: {
          text: "Literally Unhealthy",
          textth: "มีผลต่อสุขภาพมาก",
          bg: "rgba(210, 80, 80, 0.9)",
          img: require("@/assets/images/yamahaaqi/lv/lv4.png"),
          color: "#610e06",
        },
        lv5: {
          text: "Very Unhealthy",
          textth: "มีผลต่อสุขภาพมาก",
          bg: "rgba(209, 73, 168, 0.9)",
          img: require("@/assets/images/yamahaaqi/lv/lv5.png"),
          color: "#67174F",
        },
        lv6: {
          text: "Hazardous",
          textth: "อันตรายต่อสุขภาพ",
          bg: "rgba(224, 169, 76, 0.9)",
          img: require("@/assets/images/yamahaaqi/lv/lv6.png"),
          color: "#745726",
        },
      },
      color_condi: {
        lv1: {
          text: "Excellent",
          head: "rgba(59, 204, 255, 0.9)",
          cr: "#93DEF5",
          bg: "rgba(223, 238, 240, 0.9)",
          color: "#3BCCFF",
        },
        lv2: {
          text: "Good",
          head: "rgba(98, 201, 147, 0.9)",
          cr: "#90E4B8",
          bg: "rgba(185, 226, 205, 0.9)",
          color: "#22600C",
        },
        lv3: {
          text: "Moderate",
          bg: "rgba(240, 240, 223, 0.9)",
          cr: "#F5F293",
          head: "rgba(255, 248, 54, 0.9)",
          color: "#AB960F",
        },
        lv4: {
          text: "Unhealthy",
          bg: "rgba(240, 231, 223, 0.9)",
          cr: "#F5C193",
          head: "rgba(255, 146, 54, 0.9)",
          color: "#BF7C2F",
        },
        lv5: {
          text: "Very Unhealthy",
          bg: "rgba(240, 223, 223, 0.9)",
          cr: "#F59393",
          head: "rgba(255, 54, 54, 0.9)",
          color: "#BF2F2F",
        },
      },
    };
  },
};
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: 33.3% 33.3% 33.3%;
  grid-template-rows: 30% 10% 30% 10% 20%;
  gap: 0px 0px;
  height: 100%;
  grid-auto-flow: row;
  grid-template-areas:
    "i-aqi i-aqi i-aqi"
    "i-name i-name i-name"
    "i-i1 i-i2 i-i3" "i-name2 i-name2 i-name2" "i-o i-o i-o";
}

.i-aqi {
  grid-area: i-aqi;
  height: 160px;
}

.i-name {
  grid-area: i-name;
  /* height: 100px; */
}
.i-name2 {
  grid-area: i-name2;
  /* height: 100px; */
}
.i-i1 {
  grid-area: i-i1;
  height: 150px;
}

.i-i2 {
  grid-area: i-i2;
  height: 150px;
}

.i-i3 {
  grid-area: i-i3;
  height: 150px;
}
.i-o {
  grid-area: i-o;
}
.carddiv {
  height: auto;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  display: block;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
</style>